angular.module('lingoda.fields.date', [])
//Deprecated
.directive('lingInputTimepicker', function() {
    return {
        restrict:'A',
        link: function(scope, iElement) {
            iElement.timepicker();
        }
    }
})
.directive('lingInputDatepicker', ['$compile', '$timeout', '$parse', function ($compile, $timeout, $parse) {
    return {
        restrict:'A',
        link: function(scope, element, attrs) {
            var render = !attrs.render || attrs.render === 'true',
                minDate = null,
                setMinDate = function(v) {
                    if(v) {
                        minDate = moment(v).toDate(),
                        element.datepicker('fill');
                        checkMinDate();
                    }
                },
                checkMinDate = function() {
                    if(render && minDate) {
                        if(minDate.valueOf() > moment($parse(attrs.ngModel)(scope)).toDate().valueOf()) {
                            $parse(attrs.ngModel).assign(scope, '');
                        }
                    }
                };

            //Init
            if(render){
                if(angular.isDefined(attrs.minDate)) {
                    element.datepicker({
                        onRender: function(date) {
                            if(!minDate) return '';
                            return (minDate.valueOf() <= date.valueOf()) ? '' : 'disabled';
                        }
                    });
                } else {
                    element.datepicker();
                }

                //Default date
                if(attrs.dateDefault) {
                    element.on('show', function() {
                        if(!element.val()) {
                            element.datepicker('setValue', attrs.dateDefault);
                        }
                    });
                }
            }

            attrs.$observe('minDate', setMinDate);

            element.on('changeDate', function(e) {
                if(e.viewMode === 'days') {
                    element.datepicker('hide');
                }
            });

            element.on('changeDate change blur', function(e) {
                $parse(attrs.ngModel).assign(scope, element.val());
                checkMinDate();
                scope.$apply();
            });

            element.on('keydown', function(e) {
                if(e.which === 9) {
                    element.datepicker('hide');
                }
            });

        }
    }
}])
.directive('dateRangePickerWrapper', function() {
    return {
        restrict: 'C',
        scope: true,
        controller: ['$scope', function($scope) {
            $scope.setDate = function(v) {
                switch(v) {
                    case 'today':
                        var today = moment().format('YYYY-MM-DD');
                        $scope.from = today;
                        $scope.to = today;
                    break;
                    case 'tomorrow':
                        var tomorrow = moment().add(1, 'day').format('YYYY-MM-DD');
                        $scope.from = tomorrow;
                        $scope.to = tomorrow;
                    break;
                    case '7days':
                        $scope.from = moment().format('YYYY-MM-DD');
                        $scope.to = moment().add(7, 'days').format('YYYY-MM-DD');
                    break;
                    case 'month':
                        $scope.from = moment().format('YYYY-MM-DD');
                        $scope.to = moment().endOf('month').format('YYYY-MM-DD');
                    break;
                }
                $scope.showPanel = false;
            };

            $scope.cancel = function() {
                $scope.from = $scope.fromFinal;
                $scope.to = $scope.toFinal;
                $scope.showPanel = false;
            };

            var setPreview = function() {
                if($scope.fromFinal || $scope.toFinal) {
                    $scope.preview = ($scope.fromFinal || '') + ' - ' + ($scope.toFinal || '');
                } else {
                    $scope.preview = '';
                }
            };

            $scope.fromFinal = '';
            $scope.toFinal = '';
            $scope.$watch('fromFinal', setPreview);
            $scope.$watch('toFinal', setPreview);
        }],
        link: function (scope, element, attrs) {
            $(document).on('click', function(e) {
                if(!$(e.target).closest(element).length) {
                    scope.$apply(scope.cancel);
                }
            });
        }
    }
})
.directive('dateRangePickerFrom', ['$parse', function($parse) {
    return {
        restrict: 'C',
        link: function (scope, element, attrs) {
            scope.$watch('showPanel', function(v) {
                if(!v) {
                    $parse(attrs.ngModel).assign(scope, scope.from);
                }
            });
            scope.$watch(attrs.ngModel, function(v) {
                scope.fromFinal = v;
                scope.from = v;
            });
        }
    }
}])
.directive('dateRangePickerTo', ['$parse', function($parse) {
    return {
        restrict: 'C',
        link: function (scope, element, attrs) {
            scope.$watch('showPanel', function(v) {
                if(!v) {
                    $parse(attrs.ngModel).assign(scope, scope.to);
                }
            });
            scope.$watch(attrs.ngModel, function(v) {
                scope.toFinal = v;
                scope.to = v;
            });
            scope.$watch('to', function(v) {
                if(angular.isDefined(v) && !scope.showPanel) {
                    $parse(attrs.ngModel).assign(scope, scope.to);
                }
            });
        }
    }
}])
.directive('timeRangePickerWrapper', ['$timeout', function($timeout) {
    return {
        restrict: 'C',
        scope: true,
        controller: ['$scope', function($scope) {
            var times = [];
            for(var i = 0, value; i < 24; i++) {
                value = i < 10 ? ('0' + i) : i;
                times.push({
                    value: i,
                    hour: value,
                    text: value + ':00'
                });
            }

            $scope.cancel = function() {
                $scope.timeRangePicker.from = $scope.fromFinal;
                $scope.timeRangePicker.to = $scope.toFinal;
                $scope.showPanel = false;
            };

            var setPreview = function() {
                if($scope.fromFinal || $scope.toFinal) {

                    var from = '',
                        to = '';
                    for(var i = 0; i < times.length; i++) {
                        if($scope.fromFinal && $scope.fromFinal == times[i].value) {
                            from = times[i].text;
                        }
                        if($scope.toFinal && $scope.toFinal == times[i].value) {
                            to = times[i].text;
                        }
                    }

                    $scope.preview = from + ' - ' + to;
                } else {
                    $scope.preview = '';
                }
            };

            $scope.fromFinal = '';
            $scope.toFinal = '';
            $scope.$watch('fromFinal', setPreview);
            $scope.$watch('toFinal', setPreview);

            $scope.minTime = function(time) {
                return $scope.timeRangePicker.from <= time.value;
            };

            $scope.timesFrom = times;
            $scope.timesTo = times;
            $scope.timeRangePicker = {
                from: '',
                to: ''
            };

            $scope.$watch('timeRangePicker.from', function(v) {
                $timeout(function() {
                    $scope.$broadcast('resposelect:list:build');
                    if(parseFloat(v, 10) > parseFloat($scope.timeRangePicker.to, 10)) {
                        $scope.timeRangePicker.to = '';
                    }
                });
            });
        }],
        link: function (scope, element) {
            $(document).on('click', function(e) {
                if(!$(e.target).closest(element).length && !$(e.target).closest('.resposelect-list, .resposelect-list-link').length) {
                    scope.$apply(scope.cancel);
                }
            });
        }
    }
}])
.directive('timeRangePickerFrom', ['$parse', function($parse) {
    return {
        restrict: 'C',
        link: function (scope, element, attrs) {
            scope.$watch('showPanel', function(v) {
                if(!v) {
                    $parse(attrs.ngModel).assign(scope, scope.timeRangePicker.from);
                }
            });
            scope.$watch(attrs.ngModel, function(v) {
                scope.fromFinal = v;
                scope.timeRangePicker.from = v;
            });
        }
    }
}])
.directive('timeRangePickerTo', ['$parse', function($parse) {
    return {
        restrict: 'C',
        link: function (scope, element, attrs) {
            scope.$watch('showPanel', function(v) {
                if(!v) {
                    $parse(attrs.ngModel).assign(scope, scope.timeRangePicker.to);
                }
            });
            scope.$watch(attrs.ngModel, function(v) {
                scope.toFinal = v;
                scope.timeRangePicker.to = v;
            });
            scope.$watch('timeRangePicker.to', function(v) {
                if(angular.isDefined(v) && !scope.showPanel) {
                    $parse(attrs.ngModel).assign(scope, scope.timeRangePicker.to);
                }
            });
        }
    }
}]);
